import { TONE_CLASSES } from "../assets/assetUtils";

const BLUE = "text-blue-700 bg-blue-50 border-blue-200 dark:text-blue-400 dark:bg-blue-950/30 dark:border-blue-800";

export const CELL = {
  completed: { label: "Completed", dot: "bg-emerald-500", ring: "", cls: TONE_CLASSES.ok },
  in_progress: { label: "In progress", dot: "bg-amber-500", ring: "", cls: TONE_CLASSES.soon },
  scheduled: { label: "Job scheduled", dot: "bg-blue-500", ring: "", cls: BLUE },
  overdue: { label: "Overdue", dot: "bg-red-500", ring: "ring-2 ring-red-500/40", cls: TONE_CLASSES.overdue },
  missed: { label: "Missed (no job)", dot: "bg-transparent border-2 border-red-500", ring: "", cls: TONE_CLASSES.overdue },
  planned: { label: "Planned", dot: "bg-transparent border-2 border-muted-foreground/50", ring: "", cls: TONE_CLASSES.none },
  skipped: { label: "Skipped", dot: "bg-muted-foreground/30", ring: "", cls: TONE_CLASSES.none },
  cancelled: { label: "Cancelled", dot: "bg-muted-foreground/30", ring: "", cls: TONE_CLASSES.none },
};

export const ROW_STATE = {
  overdue: { label: "Overdue", cls: TONE_CLASSES.overdue },
  missed: { label: "Missed", cls: TONE_CLASSES.overdue },
  in_progress: { label: "In progress", cls: TONE_CLASSES.soon },
  scheduled: { label: "Scheduled", cls: BLUE },
  ok: { label: "On track", cls: TONE_CLASSES.ok },
};

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const fmtD = (iso) => { if (!iso) return "—"; const d = new Date(iso.length > 10 ? iso : iso + "T00:00:00"); return `${String(d.getDate()).padStart(2, "0")} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`; };
export const fmtShort = (iso) => { if (!iso) return ""; const d = new Date(iso + "T00:00:00"); return `${d.getDate()} ${MONTHS[d.getMonth()]}`; };
export const monthLabel = (iso, withYear) => { const d = new Date(iso + "T00:00:00"); return `${MONTHS[d.getMonth()]}${withYear ? ` ${String(d.getFullYear()).slice(2)}` : ""}`; };
export const isoDaysAgo = (n) => { const d = new Date(); d.setDate(d.getDate() - n); return d.toISOString().slice(0, 10); };
export const todayIso = () => new Date().toISOString().slice(0, 10);

export const Pill = ({ tone, children, testid }) => (
  <span className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-medium whitespace-nowrap ${tone || TONE_CLASSES.none}`} data-testid={testid}>{children}</span>
);

export const StatePill = ({ state, testid }) => {
  const s = ROW_STATE[state] || ROW_STATE.ok;
  return <Pill tone={s.cls} testid={testid}>{s.label}</Pill>;
};

export const Spinner = () => <div className="flex justify-center py-12"><div className="animate-spin h-6 w-6 border-2 border-primary border-t-transparent rounded-full" /></div>;

export const durationText = (m) => (!m ? "" : m >= 60 ? `${Math.round((m / 60) * 10) / 10}h` : `${m}m`);
